import { MODULES } from "../../../../utils/constants";
import { routes } from "../../../../constants/routes";
import icons from "../../../../assets/icons/valid-icons";
import InfoIcon from "../../../../assets/icons/terms-info-icon.svg";
export interface MenuItem {
  label: string;
  icon?: string;
  path: string;
  subMenu?: MenuItem[];
  classNames: string;
  isOpen?: boolean;
  disabled?: boolean;
  moduleName?: string;
  isModuleEnabled?: boolean;
  permissionRole?: any[];
  onlyShowTOAFP?: boolean;
  navbarItem?: boolean;
}

export interface SidebarProps {
  menuItems: MenuItem[];
  footerItems: MenuItem[];
}

export const menuItems: MenuItem[] = [
  {
    label: "Dashboard",
    icon: icons.DashboardIcon,
    path: routes.PRENEED_DASHBOARD,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Profile Management",
    icon: icons.ProfileManagementIcon,
    path: routes.PRENEED_PROFILE_MGMT,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Service Package",
    icon: icons.ProviderServiceManagementIcon,
    path: routes.PRENEED_SERVICE_PACKAGE,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Contract Orders",
    icon: icons.BookingAppointmentIcon,
    path: routes.PRENEED_BOOKING_AND_APPOINTMENT,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Leads",
    icon: icons.LeadsIcon,
    path: routes.PRENEED_LEADS,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Payments & Billing",
    icon: icons.PaymentBillingIcon,
    path: routes.PRENEED_PAYMENTS_AND_BILLING,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Contract Templates",
    icon: icons.ContractManagement,
    path: routes.PRENEED_CONTRACT_MANAGEMENT,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "AFP Tech Support",
    icon: icons.CommunicationIcon,
    path: routes.PRENEED_COMMUNICATION,
    classNames: "",
    navbarItem: false,
  },
];

export const footerItems: MenuItem[] = [
  {
    label: "Terms of Service",
    icon: InfoIcon,
    path: routes.PRENEED_TERMS_OF_SERVICE,
    classNames: "",
    navbarItem: false,
  },
];
